import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ptBR } from 'date-fns/locale';

// date-fns speaks English when it gets no locale, and a screen in pt_BR ends up
// with "Sep 28, 2:05 PM". The app has one date-fns locale to give besides that.
export const dateFnsLocaleFor = appLocale =>
  appLocale === 'pt_BR' ? ptBR : undefined;

export function useDateLocale() {
  const { locale } = useI18n({ useScope: 'global' });
  return computed(() => dateFnsLocaleFor(locale.value));
}
